export const DOMAIN_REPO = 'DOMAIN_REPO';
export const DOMAIN_SERVICE = 'DOMAIN_SERVICE';

export const DOMAIN_ACCESS_SERVICE = 'DOMAIN_ACCESS_SERVICE';